<template>
  <div v-loading="pridobivanjePodatkovClana" v-if="podatkiOclanu !== null">
    <div class="klubBoxOsnovno">
      <div>
        <p class="navadno-besedilo">
          <div>
            Pozdravljen/a, {{ podatkiOclanu.ime }}!
          </div>
          <div>Član T-2 Kluba ste že <b>od {{ podatkiOclanu.vclanitev }}!</b></div>
        </p>
        <div>
          <el-checkbox v-model="vclanjen">
          </el-checkbox>
          <b class="primarna-barva">
            DA
          </b>, želim postati član T-2 Kluba in sem prebral ter se strinjam s splošnimi pogoji, ki so dostopni
          <a :href="splosniPogoji" target="_blank" class="primarna-barva">tukaj</a>.
        </div>
      </div>
      <div>
        <div class="postavitev-okvirckov">
          <div class="flex-container">
            <div class="box-notranja-postavitev-manjsi-stTock" v-loading="nalaganjeTock">
              <p class="open-sans-30pt">
                <b class="primarna-barva">
                  {{ steviloTock }}
                </b>
              </p>
              <p class="stil-pisave-znotraj-okvira">
                število točk
              </p>
            </div>
            <div class="box-notranja-postavitev-manjsi-stNakupov">
              <p class="open-sans-30pt">
                <b class="primarna-barva">
                  {{ steviloNarocil }}
                </b>
              </p>
              <p class="stil-pisave-znotraj-okvira">
                Število nakupov v T-2 Klubu.
              </p>
            </div>
          </div>
          <div class="postavitev-gumba-vstopite-v-klub">
            <a :href="klubUrl" target="_blank">
              <el-button class="gumb-potrdi">
                VSTOPITE V T-2 KLUB
              </el-button>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div style="padding-top: 10px" class="odmik-osebni-podatki">
      <div style="padding-bottom: 20px" class="postavitev-hr-osebni-podatki">
        <hr class="hr-stil"/>
      </div>
      <div class="osebni-podatki-brez-hr"/>
      <div>
        <p class="open-sans-20pt">
          Osebni podatki
        </p>
      </div>
      <div class="container" style="padding-top: 30px">
        <div>
          <div>
            <div style="float: left">
              <img src="/static/img/MojT2/T2Klub/Icon-awesome-user-alt.png">
            </div>
          </div>
          <div style="float: left; padding-left: 20px">
            <p>
              <span v-if="podatkiOclanu.ime !== '' || podatkiOclanu.priimek !== ''">
                {{ podatkiOclanu.ime }} {{ podatkiOclanu.priimek }}
              </span>
              <br/>
              <span v-if="podatkiOclanu.ulica !== ''">
              {{ podatkiOclanu.ulica }}
              </span>
              <span v-if="podatkiOclanu.hisnaStevilka !== ''">
              {{ podatkiOclanu.hisnaStevilka }}
              </span>
              <br/>
              <span v-if="podatkiOclanu.ptt !== '' || podatkiOclanu.kraj !== ''">
                {{ podatkiOclanu.ptt }} {{ podatkiOclanu.kraj }}
              </span>
            </p>
          </div>
        </div>
        <div>
          <div v-if="podatkiOclanu.telefon !== ''">
            <div>
              <div style="float: left">
                <img src="/static/img/MojT2/T2Klub/Icon-awesome-phone-alt.png">
              </div>
            </div>
            <div style="padding-left: 40px">
              <p>
                {{ telefonClanKluba }}
              </p>
            </div>
          </div>
          <div v-if="podatkiOclanu.email !== ''">
            <div>
              <div style="float: left">
                <img src="/static/img/MojT2/T2Klub/Icon-material-email.png">
              </div>
            </div>
            <div style="padding-left: 40px">
              <p>
                {{ podatkiOclanu.email }}
              </p>
            </div>
          </div>
        </div>
        <div v-if="podatkiOclanu.datumRojstva !== ''">
          <div style="padding-top: 10px">
            <div>
              <div style="float: left">
                <img src="/static/img/MojT2/T2Klub/Icon-awesome-birthday-cake.png">
              </div>
            </div>
            <div style="padding-left: 40px">
              <p>
                {{ podatkiOclanu.datumRojstva }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="odmik-hr-moja-narocila">
      <hr class="hr-stil"/>
    </div>

<!--    ZAKOMENTIRANO ZA KASNEJSO UPORABO-->
<!--    <div style="padding-top: 40px">-->
<!--      <div>-->
<!--        <p class="open-sans-20pt">-->
<!--          Naslovi za dostavo-->
<!--        </p>-->
<!--      </div>-->
<!--      <div class="flex-container" v-loading="pridobivanjeNaslovovDostave">-->
<!--        <div v-for="naslov in seznamKontaktovZaDostavo">-->
<!--          <div class="box">-->
<!--            <div>-->
<!--              <div style="float: left">-->
<!--                <span v-if="naslov.privzetNaslov === 'true'">-->
<!--                  <img src="/static/img/kljukica.png"/>-->
<!--                </span>-->
<!--                <span v-else>-->
<!--                  <img src=""/>-->
<!--                </span>-->
<!--              </div>-->
<!--              <div style="float: right">-->
<!--                <img src="/static/img/MojT2/T2Klub/Icon-awesome-times.png"-->
<!--                     @click="OdstraniKontaktZaDostavo(naslov)"-->
<!--                     style="cursor: pointer"/>-->
<!--              </div>-->
<!--            </div>-->
<!--            <div style="padding: 52px 23px 19px 10px">-->
<!--              <b>-->
<!--                {{ naslov.ime }} {{ naslov.priimek }}-->
<!--              </b>-->
<!--              <br/>-->
<!--              <b>-->
<!--                {{ naslov.ulica }} {{ naslov.hs }} {{ naslov.hd }}-->
<!--              </b>-->
<!--              <br/>-->
<!--              <b>-->
<!--                {{ naslov.pst }} {{ naslov.posta }}-->
<!--              </b>-->
<!--              <br/>-->
<!--              <br/>-->
<!--              <b>-->
<!--                {{ podatkiOclanu.telefon }}-->
<!--              </b>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="box" style="height: 193px; cursor: pointer" @click="UstvariDirektorij">-->
<!--          <div style="margin: 0 auto; width: 100%; padding-top: 70px;">-->
<!--            <p style="font-size: 20px; color: #d8dce6; font-weight: 900; text-align: center">-->
<!--              Dodaj naslov-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div v-if="prikaziUstvariNovNaslov === true">-->
<!--      </div>-->
<!--      <div class="postavitev-vsebine-dodajanje-naslova" v-else>-->
<!--        <p class="open-sans-20pt">-->
<!--          Dodajanje novega naslova-->
<!--        </p>-->
<!--        <div class="podatki">-->
<!--          <div>-->
<!--            <p>-->
<!--              Ime-->
<!--            </p>-->
<!--            <el-input placeholder="" v-model="novoIme"-->
<!--                      class="velikost-input" size="small">-->
<!--            </el-input>-->
<!--          </div>-->
<!--          <div>-->
<!--            <p>-->
<!--              Priimek-->
<!--            </p>-->
<!--            <el-input placeholder="" v-model="novPriimek"-->
<!--                      class="velikost-input" size="small">-->
<!--            </el-input>-->
<!--          </div>-->
<!--          <div>-->
<!--            <p>-->
<!--              Naslov-->
<!--            </p>-->
<!--            <el-select :remote-method="PredlaganiStalenNaslov"-->
<!--                       filterable-->
<!--                       placeholder=""-->
<!--                       remote-->
<!--                       allow-create-->
<!--                       reserve-keyword-->
<!--                       no-data-text="Ni podatkov"-->
<!--                       class="velikost-input"-->
<!--                       size="small"-->
<!--                       v-model="novNaslov">-->
<!--              <el-option-->
<!--                v-for="item in naslovi"-->
<!--                :key="item"-->
<!--                :label="item"-->
<!--                :value="item">-->
<!--              </el-option>-->
<!--            </el-select>-->
<!--          </div>-->
<!--          <div>-->
<!--            <p>-->
<!--              Hišna številka-->
<!--            </p>-->
<!--            <el-input type="text"-->
<!--                      v-model="hs"-->
<!--                      maxlength="7"-->
<!--                      size="small"-->
<!--                      placeholder=""-->
<!--                      class="velikost-input">-->
<!--            </el-input>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div style="padding-top: 40px">-->
<!--          <el-button type="primary" plain @click="DodajKontaktZaDostavo" class="gumb-potrdi">-->
<!--            SHRANITE SPREMEMBE-->
<!--          </el-button>-->
<!--          <a class="stil-gumb-preklici" @click="PrekliciDodajanjeNaslova">-->
<!--            Prekliči-->
<!--          </a>-->
<!--        </div>-->
<!--        <div style="clear: both"/>-->
<!--      </div>-->
<!--    </div>-->

  </div>
</template>
<script>
import Vue from 'vue'
import Validacija from 'src/assets/js/globalne_funkcije/Validacija.js'
import {povezave} from '../../../../../assets/js/Povezave/povezave'
import ClientAgent from '../../../../../assets/js/clientAgent.js'
import {
  Checkbox, Button, Option, Select, Pagination, TabPane, Tabs, Input, Table, TableColumn,
  FormItem, Form, MessageBox, Row
} from 'element-ui'
import {PrikazVsebine} from '../../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SirinaOkna'
import {
  FormatirajTelefonskoStevilko
} from '../../../../../assets/js/globalne_funkcije/GlobalnoTelefonija/FormatTelefonskeStevilke'

export default {
  name: 'ClanstvoKlubInfo',
  mixins: [PrikazVsebine, FormatirajTelefonskoStevilko],
  data () {
    return {
      splosniPogoji: '',
      klubUrl: '',
      expandRowKeys: [],
      nalaganjeTock: false,
      prikaziUstvariNovNaslov: true,
      urejanjeOsebnihPodatkov: false,
      postnaStevilka: '',
      mesto: '',
      naslov: '',
      ime: '',
      priimek: '',
      seznamKontaktovZaDostavo: [],
      pridobivanjeNaslovovDostave: false,
      novoIme: '',
      novPriimek: '',
      novNaslov: '',
      naslovi: [],
      hs: '',
      validacija: '',
      vclanjen: true,
      mejnaSirinaTabela: 1275
    }
  },
  props: {
    izbranaStranka: String,
    steviloNarocil: Number,
    steviloTock: Number,
    podatkiOclanu: Object,
    pridobivanjePodatkovClana: Boolean
  },
  watch: {
    izbranaStranka: function () {
      if (this.izbranaStranka !== null) {
        this.seznamKontaktovZaDostavo = []
        this.GetKontakteZaDostavo()
      }
    },
    vclanjen: function () {
      if (this.vclanjen === false) {
        this.IzclaniIzKluba()
      }
    }
  },
  // computed: {
  //   seznamKontaktovZaDostavo: function () {
  //     this.GetKontakteZaDostavo()
  //   }
  // },

  computed: {
    telefonClanKluba: function () {
      return this.podatkiOclanu.telefon !== undefined &&
        this.podatkiOclanu.telefon.length === 11
        ? this.VrniFormatiranoTelefonsko(this.podatkiOclanu.telefon, '5') : this.podatkiOclanu.telefon
    }
  },

  components: {
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Pagination.name]: Pagination,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs,
    [Input.name]: Input,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [FormItem.name]: FormItem,
    [Form.name]: Form,
    [Row.name]: Row
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.splosniPogoji = povezave.BASE_URL_SPLOSNI_POGOJI
    this.klubUrl = povezave.BASE_URL_T2_KLUB
    this.GetKontakteZaDostavo()
    this.validacija = new Validacija()
  },
  methods: {
    PrekliciUrejanjeOsebnihPodatkov () {
      this.urejanjeOsebnihPodatkov = false
    },
    UrejanjeOsebnihPodatkov () {
      this.urejanjeOsebnihPodatkov = true
    },
    PrekliciDodajanjeNaslova () {
      this.prikaziUstvariNovNaslov = true
    },
    PredlaganiStalenNaslov (preverjanje) {
      if (preverjanje.length > 3 && preverjanje !== '') {
        let ignoredWords = []
        ignoredWords.push('^ulica')
        ignoredWords.push('^ul.')
        ignoredWords.push('^ul')
        for (let i = 0; i < ignoredWords.length; i++) {
          let reg = new RegExp(ignoredWords[i])
          if (reg.test(preverjanje)) {
            let najdenNiz = reg.exec(preverjanje)
            najdenNiz += '' + najdenNiz
            preverjanje = preverjanje.substring(najdenNiz.length - 1)
            break
          }
        }
      }
      if (preverjanje.length > 3 && preverjanje !== '') {
        this.ulice = preverjanje
        let param = ['delniNaziv=' + this.ulice]
        this.clientAgent.postWsRequest(
          this,
          'autocomplete/naslov/Naslov',
          param,
          null,
          'SetPredlaganStalenNaslov',
          'ErrPredlaganStalenNaslov')
      } else {
        this.naslovi = []
      }
    },
    SetPredlaganStalenNaslov (podatki) {
      this.naslovi = podatki.data
    },
    ErrPredlaganStalenNaslov (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
    },
    DodajKontaktZaDostavo () {
      if (this.izbranaStranka !== '' || this.novoIme !== '' || this.novPriimek !== '' || this.novNaslov !== '' ||
        this.hs !== '') {
        if (!this.validacija.HisnaStevilkaValidation(this.hs)) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Vpisali ste hišno številko ki je še nimamo zabeležene v sistemu. Prosimo,' +
            'preverite vpisano številko.'
          this.ShowWarningMessage(paramObvestilo)
        }
        if (!this.validacija.PreverjanjeNaslova(this.novNaslov)) {
          let paramObvestilo = {}
          paramObvestilo.message = 'Vpisali ste napačen naslov. Prosimo, poskusite ponovno.'
          this.ShowWarningMessage(paramObvestilo)
        }
        let param = ['idStranka=' + this.izbranaStranka]
        param.push('ime=' + this.novoIme)
        param.push('priimek=' + this.novPriimek)
        param.push('ulicaNaziv=' + this.novNaslov)
        param.push('hisnaSt=' + this.hs)
        this.clientAgent.postWsRequest(this,
          'klub/narocila/dodajKontaktZaDostavo?',
          param,
          null,
          'SetDodajKontaktZaDostavo',
          'ErrDodajKontaktZaDostavo')
      }
    },
    SetDodajKontaktZaDostavo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = 'Naslov za dostavo uspešno kreiran.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetKontakteZaDostavo()
      this.SetPraznaVnosnaPolja()
      this.prikaziUstvariNovNaslov = true
    },
    SetPraznaVnosnaPolja () {
      this.izbranaStranka = ''
      this.novoIme = ''
      this.novPriimek = ''
      this.novNaslov = ''
      this.hs = ''
    },
    ErrDodajKontaktZaDostavo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowErrorMessage(paramObvestilo)
      this.prikaziUstvariNovNaslov = true
    },
    GetKontakteZaDostavo () {
      if (this.izbranaStranka !== '') {
        this.pridobivanjeNaslovovDostave = true
        let param = ['idStranka=' + this.izbranaStranka]
        this.clientAgent.postWsRequest(this,
          'klub/narocila/pridobiKontakteZaDostavo?',
          param,
          null,
          'SetKontaktiZaDostavo',
          'ErrKontaktiZaDostavo')
      }
    },
    SetKontaktiZaDostavo (podatki) {
      this.seznamKontaktovZaDostavo = []
      this.seznamKontaktovZaDostavo = podatki.data
      for (let i = 0; i < this.seznamKontaktovZaDostavo.length; i++) {
        Vue.set(this.seznamKontaktovZaDostavo[0], 'privzetNaslov', 'true')
      }
      this.pridobivanjeNaslovovDostave = false
    },
    ErrKontaktiZaDostavo (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.ShowWarningMessage(paramObvestilo)
      this.pridobivanjeNaslovovDostave = false
    },
    OdstraniKontaktZaDostavo (row) {
      if (this.izbranaStranka !== '') {
        MessageBox.confirm('Ali želite odstraniti naslov ' + row.ime + ' ' + row.priimek, {
          confirmButtonText: 'Da',
          cancelButtonText: 'Prekliči',
          confirmButtonClass: 'gumb-potrdi',
          cancelButtonClass: 'gumb-preklici',
          customClass: 'opozorilo-dialog'
        }).then(() => {
          let param = ['idStranka=' + this.izbranaStranka]
          param.push('ime=' + row.ime)
          param.push('priimek=' + row.priimek)
          param.push('ulMid=' + row.ulMid)
          param.push('ulicaNaziv=' + row.ulica)
          param.push('hs=' + row.hs)
          param.push('hd=' + row.hd)
          param.push('pSt=' + row.pst)
          param.push('posta=' + row.posta)
          this.clientAgent.postWsRequest(this,
            'klub/narocila/odstraniKontaktzaDostavo?',
            param,
            null,
            'SetNaslov',
            'ErrOdstraniKontaktZaDostavo')
        }).catch((err) => {
          err = null
        })
      }
    },
    SetNaslov () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Naslov za dostavo uspešno odstranjen.'
      this.ShowSuccessMessage(paramObvestilo)
      this.GetKontakteZaDostavo()
    },
    ErrOdstraniKontaktZaDostavo (podatki) {
      this.ShowWarningMessage(podatki)
    },
    Izbranavrstica (naslov) {
      this.ime = naslov.ime
      this.priimek = naslov.priimek
      this.naslov = naslov.ulica + ' ' + naslov.hs + naslov.hd
      this.mesto = naslov.posta
      this.postnaStevilka = naslov.pst
    },
    UstvariDirektorij () {
      this.prikaziUstvariNovNaslov = false
    },
    IzclaniIzKluba () {
      if (this.vclanjen === false) {
        if (this.izbranaStranka !== '') {
          MessageBox.confirm('Ali ste prepričani, da se želite izčlaniti?', {
            confirmButtonText: 'Da',
            cancelButtonText: 'Prekliči',
            confirmButtonClass: 'gumb-potrdi',
            cancelButtonClass: 'gumb-preklici',
            customClass: 'opozorilo-dialog'
          }).then(() => {
            let param = []
            param.push('idStranka=' + this.izbranaStranka)
            this.clientAgent.postWsRequest(this,
              '/klub/klubIzclani?',
              param,
              null,
              'SetIzclaniIzKluba',
              'ErrIzclaniIzKluba')
          }).catch((err) => {
            this.vclanjen = true
            err = null
          })
        }
      }
    },
    SetIzclaniIzKluba () {
      let paramObvestilo = {}
      paramObvestilo.message = 'Uspešno ste se izčlanili iz T-2 Kluba.'
      this.$emit('ponovniKlicZaPridobivanjeVclanitve', this.izbranaStranka)
      this.ShowSuccessMessage(paramObvestilo)
    },
    ErrIzclaniIzKluba (podatki) {
      let paramObvestilo = {}
      paramObvestilo.message = podatki.message
      this.$emit('ponovniKlicZaPridobivanjeVclanitve', this.izbranaStranka)
      this.ShowWarningMessage(paramObvestilo)
    }
  }
}
</script>
<style scoped src="../../../../../../static/css/MojT-2/T2Klub/MojKlub.css">
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Mojprofil/T2klub/MojKlub.vue